import { Cabinet } from 'lib/modelBuilder/entities/Cabinet';
import { Shelf } from 'lib/modelBuilder/entities/Shelf';
import { put, select } from '@redux-saga/core/effects';
import {
  DoorHandleType,
  ECO_COLOR,
  ECO_PLUS_COLOR,
  NATURAL_COLOR,
  PositionAngle,
} from 'lib/modelBuilder/constants';
import { makeSelectHandlesSelection } from 'containers/HandlesPanel/selectors';
import { selectionHandlesAction } from 'containers/HandlesPanel/actions';
import { HandleUserSelection } from 'containers/HandlesPanel/types';
import { findColor } from 'lib/modelBuilder/utils/colorHelper';

export function* postSuccessAddDoorHandleSaga(
  cabinetNext: Cabinet,
  payload: any,
) {
  const { position } = payload;
  yield put(selectionHandlesAction([position]));
}

export function* addDoorHandleSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { type, color, material } = payload;
  const handlesSelection = yield select(makeSelectHandlesSelection());
  if (type !== DoorHandleType.Slat)
    return {
      ignore: true,
      postSuccess: null,
    };
  for (const shelf of selectedShelves) {
    for (const position of handlesSelection) {
      if (position === 'Doors') {
        for (const position of Object.values(PositionAngle)) {
          shelf.addDoorHandle(position, type, color);
        }
      } else shelf.addDoorHandle(position, type, color);
    }
  }
  return {
    ignore: false,
    postSuccess: postSuccessAddDoorHandleSaga,
  };
}

export function* postSuccessRemoveHandleSaga(
  cabinetNext: Cabinet,
  payload: any,
) {
  const handlesSelection: HandleUserSelection[] = yield select(
    makeSelectHandlesSelection(),
  );
  yield put(selectionHandlesAction([]));
}

export function* removeHandleSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const handlesSelection = yield select(makeSelectHandlesSelection());
  if (handlesSelection.length === 0 || selectedShelves.length === 0)
    return { ignore: true };
  for (const shelf of selectedShelves) {
    if (handlesSelection.length === 1 && handlesSelection[0] === 'Doors') {
      // Remove all handle doors
      shelf.removeDoorHandle();
    } else {
      for (const position of handlesSelection) {
        if (typeof position === 'number')
          throw new Error("Couldn't not remove drawers handles");
        shelf.removeDoorHandle(position);
      }
    }
  }
  return {
    ignore: false,
    postSuccess: null,
  };
}

export function* updateDoorHandleSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { type, color, material } = payload;
  const handlesSelection = yield select(makeSelectHandlesSelection());
  if (handlesSelection && handlesSelection.length > 0) {
    for (const shelf of selectedShelves) {
      for (const pos of handlesSelection) {
        if (pos === 'Doors') {
          for (const position of Object.values(PositionAngle)) {
            shelf.addDoorHandle(position, type, color);
          }
        } else if (pos === 'Slats') {
          for (const position of Object.values(PositionAngle)) {
            shelf.setLargeDoorSlat(position, material);
          }
        } else if (shelf.isBigShelf()) {
          shelf.setLargeDoorSlat(pos, material);
        } else shelf.addDoorHandle(pos, type, color);
      }
    }
    return {
      ignore: false,
      postSuccess: null,
    };
  }
  return { ignore: true };
}

export function* prepareHandleSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  for (const shelf of selectedShelves) {
    shelf.prepareHandle();
  }
  return {
    ignore: false,
    postSuccess: null,
  };
}

export function* postSuccessAddDDrawerHandleSaga(
  cabinetNext: Cabinet,
  payload: any,
) {
  const { position } = payload;
  yield put(selectionHandlesAction([position]));
}

// export function* addDDrawerHandleSaga(
//   cabinetOrigin: Cabinet,
//   cabinetNext: Cabinet,
//   payload: any,
//   selectedShelves: Shelf[],
// ) {
//   const { type, color } = payload;
//   const handlesSelection = yield select(makeSelectHandlesSelection());
//
//   for (let shelf of selectedShelves) {
//     for (let position of handlesSelection) {
//       if (position === 'Drawers') {
//         for (let position of Array.from(Array(shelf.drawers.length).keys())) {
//           shelf.addDrawerHandle(position, type, color);
//         }
//       } else shelf.addDoorHandle(position, type, color);
//     }
//   }
//   return {
//     ignore: false,
//     postSuccess: postSuccessAddDDrawerHandleSaga,
//   };
// }

export function updateMaterialWhenEco(shelf: Shelf, position: number) {
  const drawer = shelf.getDrawer(position);
  if (drawer) {
    if (
      drawer.color.reference === ECO_COLOR ||
      drawer.color.reference === ECO_PLUS_COLOR
    ) {
      shelf.updateDrawer(
        position,
        undefined,
        undefined,
        undefined,
        findColor(NATURAL_COLOR),
      );
    }
  }
}

export function* updateDrawerHandleSaga(
  cabinetOrigin: Cabinet,
  cabinetNext: Cabinet,
  payload: any,
  selectedShelves: Shelf[],
) {
  const { type, color, previousFrontColor } = payload;
  const handlesSelection = yield select(makeSelectHandlesSelection());
  if (handlesSelection && handlesSelection.length > 0) {
    for (const shelf of selectedShelves) {
      for (const pos of handlesSelection) {
        if (pos === 'Drawers') {
          for (const position of Array.from(
            Array(shelf.drawers.length).keys(),
          )) {
            shelf.addDrawerHandle(position, type, color, previousFrontColor);
            updateMaterialWhenEco(shelf, position);
          }
        } else {
          shelf.addDrawerHandle(pos, type, color, previousFrontColor);
          updateMaterialWhenEco(shelf, pos);
        }
      }
    }
    return {
      ignore: false,
      postSuccess: null,
    };
  }
  return { ignore: true };
}
